// extracted by mini-css-extract-plugin
export default {"styles":"styles___WaqlR","total":"total___jKAdp","Content":"Content___He9pD"};